var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hold-capacity-config"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab === 'upload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hold Capacity Config File")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    ref: "fileInput",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile",
      "accept": ".csv"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv files allowed. Max size 5 MB.")])], 1), _vm._v(" "), (_vm.parseError) ? _c('small', {
    staticClass: "text-danger d-block"
  }, [_vm._v(_vm._s(_vm.parseError))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "Download Hold Capacity Config sample .csv"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadSampleCsv.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Hold Capacity Config Sample\n                    ")])], 1), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download failed rows"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("\n                          Download "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "expected-column"
  }, [_c('div', {
    staticClass: "expected-title"
  }, [_vm._v("Expected columns:")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, _vm._l((_vm.mappingColumns), function(col) {
    return _c('span', {
      key: col.key,
      class: ['column-tag', col.required ? 'mandatory' : 'optional'],
      attrs: {
        "title": col.required ? 'Required column' : 'Optional column'
      }
    }, [_vm._v("\n                          " + _vm._s(col.header) + "\n                        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n                        Column headers in the uploaded file are normalized (casing and extra spaces).\n                        Hub Name, Hold Area Capacity, and PTL Capacity are required on every row.\n                        Hold Area Capacity and PTL Capacity must be positive whole numbers.\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" Re-uploading for the same Hub Name overwrites the existing config.\n                      ")])])])]), _vm._v(" "), (_vm.lastUploadSummary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-summary"
  }, [_c('div', {
    staticClass: "upload-summary-title"
  }, [_vm._v("Last upload summary")]), _vm._v(" "), _c('div', {
    staticClass: "upload-summary-body"
  }, [(_vm.lastUploadSummary.totalRows != null) ? _c('span', {
    staticClass: "upload-summary-chip total"
  }, [_vm._v("\n                          Total rows: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.validCount != null) ? _c('span', {
    staticClass: "upload-summary-chip valid"
  }, [_vm._v("\n                          Valid: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.validCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.insertedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip inserted"
  }, [_vm._v("\n                          New inserted: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.insertedCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.updatedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip updated"
  }, [_vm._v("\n                          Existing updated: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.updatedCount))])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload Hold Capacity Config file",
      "disabled": !_vm.parsedRows.length || !!_vm.parseError || _vm.isLoadingUpload
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearching
    },
    on: {
      "update:active": function($event) {
        _vm.isSearching = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Hold Capacity Mappings")]), _vm._v(" "), _c('div', {
    style: (_vm.mappings.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hold Area Capacity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PTL Capacity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.mappings), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.pageno * _vm.limit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.hubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.hold_area_capacity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.ptl_capacity != null ? row.ptl_capacity : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.lastmodifiedby || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("momentIst")(row.lastmodifieddate)))])])
  }), _vm._v(" "), (_vm.mappings.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > _vm.limit),
      expression: "totalRows > limit"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : (_vm.currentTab === 'history') ? _c('b-card', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingHistory
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingHistory = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Upload History")]), _vm._v(" "), _c('div', {
    style: (_vm.historyRows.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Old Hold Cap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("New Hold Cap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Old PTL Cap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("New PTL Cap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.historyRows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.historyPageno * _vm.historyLimit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: _vm.auditActionBadgeClass(row.action)
    }, [_vm._v(_vm._s(row.action))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.old_hold_area_capacity != null ? row.old_hold_area_capacity : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.new_hold_area_capacity != null ? row.new_hold_area_capacity : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.old_ptl_capacity != null ? row.old_ptl_capacity : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.new_ptl_capacity != null ? row.new_ptl_capacity : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.changed_by || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("momentIst")(row.changed_at)))])])
  }), _vm._v(" "), (_vm.historyRows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyTotalRows > _vm.historyLimit),
      expression: "historyTotalRows > historyLimit"
    }],
    attrs: {
      "page-count": _vm.historyPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getHistoryPagination,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e()], 1)], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("Hold Capacity Config")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7749292c","hasScoped":true}!./src/views/components/HoldCapacityConfig/HoldCapacityConfig.html
// module id = 1121
// module chunks = 2